<template>
  <section class="all-documents-view !rounded-xl heightClass">
    <div
      class="flex flex-col md:flex-row items-start md:items-center justify-between gap-2 md:!gap-4 !px-3 !pb-2 border-b border-page-border sticky top-0 bg-container-background z-[1] !pt-3 !rounded-t-xl"
      v-loading.fullscreen.lock="fullscreenLoading"
    >
      <h1
        class="!text-sm 2xl:!text-base !font-normal !text-black-950 !m-0 !max-w-64 2xl:!max-w-[500px] truncate"
      >
        Integrations
      </h1>
      <div
        class="flex items-center justify-start md:!justify-end !gap-3 flex-wrap md:!flex-nowrap flex-1"
      >
        <el-input
          class="max-w-44"
          placeholder="Search..."
          prefix-icon="el-icon-search"
          size="mini"
          v-model="searchInput"
        />
        <el-button
          style="background: var(--brand-500) !important"
          class="!py-1.5 !px-4 !rounded-sm hover:!bg-brand-500 !border-none !m-0 !h-auto"
          type="primary"
          @click="showCreateAppDialog"
        >
          <span class="flex items-center !gap-1.5">
            <img src="@/assets/img/icons/new/add-icon.svg" alt="" class="!size-3" />
            <span class="text-xs font-light text-white">Create an app</span>
          </span>
        </el-button>
      </div>
    </div>
    <div class="!px-3 !pt-3">
      <el-table
        :data="allClients"
        :fullscreen="true"
        style="width: 100%; border: 1px solid #ebeef5; margin: 0px"
        v-loading="tableLoading"
      >
        <!-- Loop over columns -->
        <el-table-column
          v-for="(column, index) in clientColumns"
          :key="index"
          :prop="column.prop"
          :label="column.label"
        >
          <template slot-scope="scope">
            <span v-if="column.prop === 'appName'" style="color: red !important">
              <a href="#" @click.prevent="gotoClientPage(scope.row)" style="color: #3a86fc">
                {{ scope.row[column.prop] }}
              </a>
            </span>
            <span v-else-if="column.prop === 'logo'">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                fill="currentColor"
                class="bi bi-opencollective"
                viewBox="0 0 16 16"
              >
                <path
                  fill-opacity=".4"
                  d="M12.995 8.195c0 .937-.312 1.912-.78 2.693l1.99 1.99c.976-1.327 1.6-2.966 1.6-4.683 0-1.795-.624-3.434-1.561-4.76l-2.068 2.028c.468.781.78 1.679.78 2.732z"
                />
                <path
                  d="M8 13.151a4.995 4.995 0 1 1 0-9.99c1.015 0 1.951.273 2.732.82l1.95-2.03a7.805 7.805 0 1 0 .04 12.449l-1.951-2.03a5.07 5.07 0 0 1-2.732.781z"
                />
              </svg>
              <!-- <i class="el-icon-document" style="font-size:25px"></i> -->
            </span>
            <span v-else-if="column.prop === 'status'">
              <span v-if="scope.row[column.prop] === 'Active'">
                <span class="circle-shape" style="background-color: green"></span>
                {{ scope.row[column.prop] }}
              </span>
              <span v-else>
                <span class="circle-shape" style="background-color: black"></span>
                {{ scope.row[column.prop] }}
              </span>
            </span>
            <span v-else-if="column.prop === 'action'">
              <el-popconfirm
                title="Are you sure to delete this?"
                @confirm="onDeleteConfirmed(scope.row)"
              >
                <el-button slot="reference" type="danger" size="mini" plain class="px-2 ml-2">
                  <i class="el-icon-delete"></i>
                </el-button>
              </el-popconfirm>
            </span>
            <span v-else>{{ scope.row[column.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <dialog-component
      :title="'Create an app'"
      :visible="clientAddDialogVisible"
      :containerWidth="getIsMobile ? '100%' : '35%'"
      :containerHeight="'30%'"
      @before-close="clientAddDialogVisiblePop"
    >
      <div class="!mt-4">
        <div class="text-lightGray text-xs 2xl:!text-sm !font-normal !mb-1 block">
          What's your app name?
        </div>
        <el-input
          placeholder="Enter an application name"
          v-model="clientAPPInfo.appName"
          clearable
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="clientAddDialogVisible = false"
          class="bg-transparent text-black-700 !px-4 !py-1 !rounded-md !text-xs 2xl:!text-sm !border !border-black/10 !mr-1 hover:!text-brand-500 hover:!border-brand-500"
        >
          Cancel
        </el-button>
        <el-button
          style="background: var(--brand-500) !important"
          class="!text-white !px-4 !py-1.5 !rounded-md !text-xs 2xl:!text-sm !border-none"
          type="button"
          @click="createApp"
        >
          Create App
        </el-button>
      </span>
    </dialog-component>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'Developer-Portal',
    data() {
      return {
        searchInput: '',
        clientAPPInfo: {
          appName: '',
          logo: '',
        },
        clientAddDialogVisible: false,
        allClients: [],
        clientColumns: [
          {
            prop: 'logo',
            label: 'Logo',
          },
          {
            prop: 'appName',
            label: 'App Name',
          },
          {
            prop: 'status',
            label: 'Status',
          },
          {
            prop: 'updated_at',
            label: 'Last modified',
          },
          {
            prop: 'created_at',
            label: 'Created at',
          },
          {
            prop: 'action',
            label: 'Action',
          },
        ],
        fullscreenLoading: false,
        tableLoading: false,
        deletePopoverVisible: false,
      };
    },
    computed: {
      ...mapGetters('navigationOpen', ['getIsMobile']),
      ...mapGetters('oauth', ['getclientData', 'getAllClientsData', 'getDeleteClientAppById']),
    },
    async mounted() {
      this.getAllClientApps();
    },
    methods: {
      clientAddDialogVisiblePop() {
        this.clientAddDialogVisible = false;
      },
      showCreateAppDialog() {
        this.clientAPPInfo.appName = '';
        this.clientAPPInfo.logo = '';
        this.clientAddDialogVisible = true;
      },
      async createApp() {
        this.fullscreenLoading = true;
        let params = {
          clientAppInfo: this.clientAPPInfo,
        };
        await this.$store.dispatch('oauth/createClientData', params);
        if (this.getclientData && this.getclientData.data) {
          this.getclientData.data.created_at = this.getDateFormat(
            this.getclientData.data.created_at
          );
          this.getclientData.data.updated_at = this.getDateFormat(
            this.getclientData.data.updated_at
          );
          this.allClients.push(this.getclientData.data);
          this.$notify({
            title: 'Success',
            message: 'App created Successfully',
            type: 'success',
          });
        } else {
          this.$notify({
            title: 'Error',
            message: 'Error in creating App',
            type: 'error',
          });
        }
        this.clientAddDialogVisible = false;
        this.fullscreenLoading = false;
      },
      async getAllClientApps() {
        this.fullscreenLoading = true;
        this.allClients = [];
        await this.$store.dispatch('oauth/fetchAllClientApps');
        if (
          this.getAllClientsData &&
          this.getAllClientsData.data &&
          this.getAllClientsData.data.length > 0
        ) {
          this.getAllClientsData.data.map(async (client) => {
            client.created_at = await this.getDateFormat(client.created_at);
            client.updated_at = await this.getDateFormat(client.updated_at);
          });
          this.allClients = this.getAllClientsData.data;
        }
        this.fullscreenLoading = false;
      },
      gotoClientPage(row) {
        this.fullscreenLoading = true;
        setTimeout(() => {
          this.$router.push(`/developer/app-detail/${row._id}/portal`).finally(() => {
            console.log('pushed to new route');
          });
        }, 1000);
      },
      async onDeleteConfirmed(row) {
        this.fullscreenLoading = true;
        await this.$store.dispatch('oauth/deleteClientApp', { appId: row._id });
        if (this.getDeleteClientAppById) {
          this.$notify({
            title: 'Success',
            message: 'App deleted Successfully',
            type: 'success',
          });
          await this.getAllClientApps();
        } else {
          this.$notify({
            title: 'Error',
            message: 'Error in deleting App',
            type: 'error',
          });
          await this.getAllClientApps();
        }
        this.fullscreenLoading = false;
      },
      getDateFormat(date) {
        const parsedDate = new Date(date);
        if (!isNaN(parsedDate)) {
          const year = parsedDate.getFullYear();
          const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
          const day = String(parsedDate.getDate()).padStart(2, '0');
          const hours = String(parsedDate.getHours()).padStart(2, '0');
          const minutes = String(parsedDate.getMinutes()).padStart(2, '0');
          const seconds = String(parsedDate.getSeconds()).padStart(2, '0');

          const formattedDate = `${month}-${day}-${year} ${hours}:${minutes}:${seconds}`;
          return formattedDate;
        }
      },
    },
  };
</script>
<style scoped>
  .el-table .el-table__cell {
    padding: 0px !important;
  }
  .circle-shape {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
</style>
